import * as React from 'react'
import Icon from '../Icon/Icon'

interface IValidateButtonProps {
  onClick: (e: React.MouseEvent) => void
  validateLabel?: string
  finishStepAction?: boolean
}

class ValidateButton extends React.Component<IValidateButtonProps> {
  private ValidateButtonRef = React.createRef<HTMLButtonElement>()
  public constructor(props: IValidateButtonProps) {
    super(props)
  }

  public componentDidMount() {
    if (this.ValidateButtonRef.current) {
      this.ValidateButtonRef.current.focus()
    }
  }

  public render() {
    return (
      <button
        className="ValidateButton"
        onClick={this.props.onClick}
        type="submit"
        ref={this.props.finishStepAction ? this.ValidateButtonRef : ''}
      >
        <Icon name="check" />
        {this.props.validateLabel === undefined ? 'Je continue' : this.props.validateLabel}
      </button>
    )
  }
}

export default ValidateButton



// WEBPACK FOOTER //
// ./src/components/ValidateButton/ValidateButton.tsx